import { render, staticRenderFns } from "./PopupEmailHistoryResultListComponent.vue?vue&type=template&id=264e8acf&scoped=true"
import script from "./PopupEmailHistoryResultListComponent.vue?vue&type=script&lang=js"
export * from "./PopupEmailHistoryResultListComponent.vue?vue&type=script&lang=js"
import style0 from "./PopupEmailHistoryResultListComponent.vue?vue&type=style&index=0&id=264e8acf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264e8acf",
  null
  
)

export default component.exports